import {CommonDoc} from "../../../../shared/services/firebase/domain.firebase";

export const UserLogs = {
    colName: "user_logs",

    ...CommonDoc,
}
